export default "__VITE_ASSET__EE_dKGW0__"